<!--PRESENTACION-->

<div class="slide">
    <div class="course-presentation">
        <div class="flex items-center justify-between gap-3 ">
            <div class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs uppercase font-normal"
                style="background: color-mix(in srgb, var(--v2-color-secondary-400), white 92%); color: var(--v2-color-secondary-500);">
                <span class="w-1.5 h-1.5 rounded-full" style="background: var(--v2-color-secondary-500);"></span>
                <span> {{ 'words.presentation' | translate }} </span>
            </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-3 pb-4">
            <div class="lg:col-span-2">
                    <msc-heading-actions [showMenu]="false">
                        <h2 class="heading text-gray-700 pb-2">
                            <span *ngIf="course.type || course.template?.type">
                                {{ ('player.course.' + (course.type ? course.type : course.template?.type)) | translate }}
                            </span>
                            {{ course.title || ('player.untitled-course' | translate) }}
                        </h2>
                    </msc-heading-actions>
                <p class="course-presentation__description multiline"
                    [innerHTML]="(course?.shortDescription ? course.shortDescription : course?.template?.shortDescription) | safe:'html'">
                </p>
            </div>

            <!-- DETALLES CLAVE -->
            <div class="rounded-2xl border border-[#E8EAEF] bg-white p-3 self-start">
                <div class="w-full h-32 rounded-xl overflow-hidden mb-3 bg-[#F6F7F9]">
                    <img *ngIf="course?.picture" [src]="course.picture + '?size=raw'"
                        [alt]="course?.title" class="w-full h-full object-cover">
                    <img *ngIf="!course?.picture"
                        src="https://static.myskillcamp.com/images/images_random/empty-state-7.jpg"
                        [alt]="course?.title" class="w-full h-full object-cover">
                </div>
                <span class="text-[10px] font-semibold tracking-widest text-gray-500 uppercase">
                    {{ 'exports.content_engagement.content_details' | translate }}
                </span>

                <div class="mt-3 space-y-2.5 text-sm text-gray-700">
                    <div class="flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4" style="color: hsl(var(--primary));">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        <span><strong>{{ 'player.course.duration' | translate }}:</strong>
                            {{ (course?.duration ? course.duration : course.template?.duration) | time }}</span>
                    </div>

                    <div class="flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4" style="color: hsl(var(--primary));">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M2 12h20"></path>
                            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                        </svg>
                        <span><strong>{{ 'player.course.language' | translate }}:</strong>
                            {{ course.language ? course.language.name : course.template?.language?.name }}</span>
                    </div>

                    <div class="flex items-center gap-2" style="display:none !important;" *ngIf="course.certificateAvailable || course.template?.certificateAvailable">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4" style="color: hsl(var(--primary));">
                            <path d="M8.21 13.89 7 23l5-3 5 3-1.21-9.12"></path>
                            <circle cx="12" cy="8" r="6"></circle>
                        </svg>
                        <span><strong>{{ 'words.certification' | translate }}:</strong>
                            {{ 'words.available' | translate }}</span>
                    </div>

                    <div class="flex items-center gap-2" *ngIf="course.weeklyWorkingDuration > 0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4" style="color: hsl(var(--primary));">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        <span><strong>{{ 'player.course.weekly-working-duration' | translate }}:</strong>
                            {{ course?.weeklyWorkingDuration | time }}</span>
                    </div>

                    <div class="flex items-center gap-2" *ngIf="course.type || course.template?.type">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4" style="color: hsl(var(--primary));">
                            <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                            <polyline points="2 17 12 22 22 17"></polyline>
                            <polyline points="2 12 12 17 22 12"></polyline>
                        </svg>
                        <span><strong>{{ 'player.course-word' | translate }}:</strong>
                            {{ ('type.' + (course.type ? course.type : course.template?.type)) | translate }}</span>
                    </div>

                    <div class="flex items-start gap-2" *ngIf="course.tags && course.tags.length > 0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="w-4 h-4 mt-0.5 shrink-0" style="color: hsl(var(--primary));">
                            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                            <line x1="7" y1="7" x2="7.01" y2="7"></line>
                        </svg>
                        <div>
                            <strong>{{ 'words.skills' | translate }}:</strong>
                            <span class="flex flex-wrap gap-1.5 mt-1">
                                <span *ngFor="let tag of course.tags"
                                    class="px-2 py-0.5 rounded-full bg-[#F6F7F9] border border-[#E8EAEF] text-xs text-gray-600">{{ tag }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" style="display:none !important;">
            <div class="course-presentation__img">
                <img *ngIf="course.picture" [src]="course.picture + '?size=raw'">
                <img *ngIf="!course.picture"
                    src="https://static.myskillcamp.com/images/images_random/empty-state-7.jpg">
            </div>
        </div>
   <div class="rounded-xl bg-gray-100 p-3 mt-0 mb-4"
            *ngIf="course.requirement || course.template?.requirement || course.target || course.template?.target || course.purpose || course.template?.purpose; else discoverCourse">
            <div class="rounded-2xl border border-[#E8EAEF] bg-white p-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
                <!-- Columna izquierda: Requisitos previos + Audiencia -->
                <div class="space-y-6">
                    <div *ngIf="course.requirement || course.template?.requirement">
                        <div class="flex items-center gap-2 mb-3">
                            <span class="w-7 h-7 rounded-full flex items-center justify-center" style="background: var(--secondary-200);">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="lucide lucide-circle-check w-4 h-4" style="color: var(--secondary-500);">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="m9 12 2 2 4-4"></path>
                                </svg>
                            </span>
                            <h3 class="text-base font-bold text-gray-700 m-0">{{ 'studio.create.course.requirement' | translate }}</h3>
                        </div>
                        <p class="text-sm text-[#5F6877] leading-relaxed multiline"
                            [innerHTML]="(course?.requirement ? course?.requirement : course?.template?.requirement) | safe:'html'"></p>
                    </div>

                    <div *ngIf="course.target || course.template?.target">
                        <div class="flex items-center gap-2 mb-3">
                            <span class="w-7 h-7 rounded-full flex items-center justify-center" style="background: var(--secondary-200);">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="w-4 h-4" style="color: var(--secondary-500);">
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="9" cy="7" r="4"></circle>
                                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                </svg>
                            </span>
                            <h3 class="text-base font-bold text-[#22304C] m-0">{{ 'studio.create.course.audience' | translate }}</h3>
                        </div>
                        <p class="text-sm text-[#5F6877] leading-relaxed multiline"
                            [innerHTML]="(course?.target ? course?.target : course?.template?.target) | safe:'html'"></p>
                    </div>
                </div>

                <!-- Columna derecha: Lo que vas a aprender / Propósito -->
                <div *ngIf="course.purpose || course.template?.purpose">
                    <div class="flex items-center gap-2 mb-3">
                        <span class="w-7 h-7 rounded-full flex items-center justify-center" style="background: var(--secondary-200);">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-lightbulb w-4 h-4" style="color: var(--secondary-500);">
                                <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path>
                                <path d="M9 18h6"></path>
                                <path d="M10 22h4"></path>
                            </svg>
                        </span>
                        <h3 class="text-base font-bold text-[#22304C] m-0">{{ 'studio.create.course.purpose' | translate }}</h3>
                    </div>
                    <div class="text-sm text-[#5F6877] multiline"
                        [innerHTML]="(course?.purpose ? course?.purpose : course?.template?.purpose) | safe:'html'"></div>
                </div>
            </div>
        </div>
        <!-- Botones -->
        <div class="course-actions-bar">
            <div class="course-actions-bar__left">
                <div class="m-unsubscribe w-100"
                    *ngIf="course.courseSubscriptionId && !external && !course.subscription?.isFromGroup"
                    (click)="openModalUnsubscribe(modalUnsubscribe)">
                    <button
                        class="inline-flex items-center w-100 justify-center rounded-full border border-gray-300 bg-gray-100 px-5 py-2.5 text-sm font-normal text-gray-700 transition-colors hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2">
                        {{ 'words.unsubscribe-course' | translate }}
                    </button>
                </div>

                <div class="m-unsubscribe w-100" *ngIf="!course.courseSubscriptionId && !preview">
                    <button class="course-actions-bar__btn course-actions-bar__btn--ghost" [disabled]="true">
                        <span>{{ 'words.unsubscribe-course' | translate }}</span>
                        <i class="icon icon-info-outline"></i>
                        <span class="tooltip"
                            [attr.data-tooltip]="'words.unsubscribe-journey.title' | translate"></span>
                    </button>
                </div>
            </div>

            <div class="course-actions-bar__right" *ngIf='course.sections.length > 0'>
                <button [routerLink]="['section', firstSectionId]" queryParamsHandling="merge"
                    class="course-actions-bar__btn course-actions-bar__btn--primary">
                    {{ 'player.course.start' | translate }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 12h14"></path>
                        <path d="m12 5 7 7-7 7"></path>
                    </svg>
                </button>
            </div>
        </div>
        <!-- progress -->
        <div class="py-3">
            <!-- TU PROGRESO -->
            <div class="rounded-2xl bg-white p-6 border border-[#E8EAEF]">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:divide-x md:divide-[#E8EAEF]">

                    <!-- NOTA FINAL -->
                    <div class="flex items-center gap-3">
                        <!-- Ícono medalla/certificado: fondo gris claro, ícono text-gray-700 -->
                        <span class="w-11 h-11 rounded-xl bg-gray-100 flex items-center justify-center flex-shrink-0 text-gray-700">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="w-5 h-5">
                                <circle cx="12" cy="8" r="6"></circle>
                                <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
                            </svg>
                        </span>
                        <div>
                            <p class="text-[11px] font-semibold tracking-wider uppercase text-gray-700 mb-2">
                                {{ 'words.rating' | translate }}
                            </p>
                            <!-- overallScore: nota/score promedio GENERAL del curso (autoritativo desde reporting; fallback al valor local) -->
                            <h2 class="text-3xl font-bold text-gray-700 flex items-baseline leading-none">
                                {{ overallScore | number:'1.0-0' }}<span class="text-base font-bold text-gray-700 ml-0.5">/100</span>
                            </h2>
                        </div>
                    </div>

                    <!-- PROGRESO -->
                    <div class="md:pl-6">
                        <p class="text-[11px] font-semibold tracking-wider uppercase text-gray-700 mb-2">
                            {{ 'player.course.progress' | translate }}
                        </p>

                        <!-- Porcentaje grande + conteo de lecciones alineado a la derecha -->
                        <div class="flex items-center  gap-4 mb-1">
                            <!-- overallProgress: % de progreso GENERAL del curso (autoritativo desde reporting; fallback al valor local) -->
                            <h2 class="text-3xl font-bold text-gray-700 flex items-baseline leading-none flex-shrink-0">
                                {{ overallProgress | number:'1.0-0' }}<span class="text-2xl font-bold ml-0.5">%</span>
                            </h2>
                            <!-- Conteo de lecciones -->
                            <span class="text-xs text-gray-500 flex-shrink-0">
                                <!-- completedLessons: lecciones realmente completadas (cuenta sesiones con doneAt) / totalLessons: total de lecciones del curso -->
                               ({{ completedLessons }} {{ 'words.of' | translate }} {{ totalLessons }} {{ 'player.section.lessons' | translate }})
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>

     

        <ng-template #discoverCourse>
            <div class="rounded-xl bg-gray-100 p-3 mt-0 mb-4">
                <div class="rounded-2xl border border-[#E8EAEF] bg-white p-6">
                    <div class="flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-sparkles w-4 h-4 text-gray-700">
                            <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
                           <!-- <path d="M20 3v4"></path>
                            <path d="M22 5h-4"></path>
                            <path d="M4 17v2"></path>
                            <path d="M5 18H3"></path>-->
                        </svg>
                        <h3 class="text-base font-bold text-[#22304C] m-0">{{ 'player.course.discover-this-course' | translate }}</h3>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>

    <div *ngIf="events && events.length > 0">
        <h2 class="heading pb-3 text-gray-700">{{ 'player.course.events.title' | translate }}</h2>
        <p>{{ 'player.course.events.description' | translate }}</p>

        <table class="table">
            <tr *ngFor="let event of events">
                <td><strong>{{ event.name }}</strong></td>
                <td *ngIf="(event?.eventSessions[0]?.startAt | date:'dd') !== (event?.eventSessions[0]?.endAt | date:'dd')"
                    class="date">
                    {{ event?.eventSessions[0]?.startAt | amDateFormat:'D' }}
                    {{ 'date.'+(event?.eventSessions[0]?.startAt | amDateFormat:'MMMM') | translate }}
                    {{ event?.eventSessions[0]?.startAt | amDateFormat:'H:mm' }} - {{ event?.eventSessions[0]?.endAt |
                    amDateFormat:'D' }}
                    {{ 'date.'+(event?.eventSessions[0]?.endAt | amDateFormat:'MMMM') | translate }}
                    {{ event?.eventSessions[0]?.endAt | amDateFormat:'H:mm' }}
                    <div>
                        <a [href]="event?.eventSessions[0]?.icsCalendar">{{ 'event.event-session.download.add-calendar'
                            | translate }}</a>
                    </div>
                </td>

                <td *ngIf="(event?.eventSessions[0]?.startAt | date:'dd') === (event?.eventSessions[0]?.endAt | date:'dd')"
                    class="date">
                    {{ event?.eventSessions[0]?.startAt | amDateFormat:'D' }}
                    {{ 'date.'+(event?.eventSessions[0]?.startAt | amDateFormat:'MMMM') | translate }}
                    {{ event?.eventSessions[0]?.startAt | amDateFormat:'H:mm' }} - {{ event?.eventSessions[0]?.endAt |
                    amDateFormat:'H:mm' }}
                    <div>
                        <a [href]="event.eventSessions[0].icsCalendar">{{ 'event.event-session.download.add-calendar' |
                            translate }}</a>
                    </div>
                </td>

                <td class="place">{{ event?.eventSessions[0]?.address || "-" }}</td>
            </tr>
        </table>
    </div>
</div>

<ng-template #modalUnsubscribe let-modal>
    <div class="modal-header">
        <span></span>
        <button type="button" class="close" aria-label="Close" (click)="modal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="m-modal-title">
            <ng-container *ngIf="course.title; else noTitle">
                {{ 'content.delete.subscription_new.title' | translate : {title: course.title} }}
            </ng-container>
            <ng-template #noTitle>
                {{ 'content.delete.subscription.title' | translate }}
            </ng-template>
        </div>

        <div class="m-modal-description" [innerHTML]="'content.delete.subscription_new.description' | translate"></div>

        <div class="m-modal-message">
            <label style="text-align: center;">{{ 'content.delete.subscription_new.message' | translate }}</label>
            <textarea [(ngModel)]="data.message"></textarea>
        </div>

        <div class="m-modal-actions">
            <div class="">
                <button class="btn btn_color_grey" (click)="modal.close()">
                    {{ 'words.cancel' | translate }}
                </button>
            </div>

            <div class="">
                <button class="btn" (click)="unsubscribe()">
                    <div class="lds-ring" *ngIf="loading">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                    <span>{{ 'words.unsubscribe' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!-- <ng-template #modalUnsubscribe let-modal>
    <span class="btn-action_close" (click)="modal.close()">+</span>

    <div class="m-modal-content">
        <div class="m-modal-title">
            {{ 'words.unsubscribe-course.title' | translate }}
        </div>

        <div class="m-modal-description" [innerHTML]="'words.unsubscribe-course.description' | translate"></div>

        <div class="m-modal-message">
            <textarea [(ngModel)]="data.message"></textarea>
        </div>

        <div class="m-modal-actions">
            <div class="">
                <button class="btn btn_color_grey" (click)="modal.close()">
                    {{ 'words.cancel' | translate }}
                </button>
            </div>

            <div class="">
                <button class="btn" (click)="unsubscribe()">
                    <div class="lds-ring" *ngIf="loading">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                    <span>{{ 'player.common.validate' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template> -->